import styled from 'styled-components';

export const UpdatePageWrapper = styled.div``;

export const HeaderWrapper = styled.div`
  text-align: center;
  margin: 0px 0px;
`;

export const SectionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
  overflow-wrap: anywhere;
`;
